/** Preserve period, profile and billing status when the existing filter panel closes. */
export function applyBillingFilters(current: Record<string, any>, selection: Record<string, any>): Record<string, any> {
  const result = { ...current };
  for (const key of ['settlement_id', 'building_id', 'floor_id', 'unit_id', 'legal_entity_id']) delete result[key];
  const selected = Object.fromEntries(Object.entries(selection).filter(([, value]) => value !== null && value !== undefined && value !== ''));
  return { ...result, ...selected, page: 1 };
}
